const SituableBlocks = {
    blocks: [
        {
            title: 'GOVERNMENT_BODIES',
            description: 'GOVERNMENT_BODIES_DESCRIPTION',
            text: 'GOVERNMENT_BODIES_TEXT'
        },
        {
            title: 'POLITICAL_AND_PUBLIC_ORGANIZATIONS',
            description: 'POLITICAL_AND_PUBLIC_ORGANIZATIONS_DESCRIPTION',
            text: 'POLITICAL_AND_PUBLIC_ORGANIZATIONS_TEXT'
        },
        {
            title: 'BUSINESS_AND_FINANCE',
            description: 'BUSINESS_AND_FINANCE_DESCRIPTION',
            text: 'BUSINESS_AND_FINANCE_TEXT'
        },
        {
            title: 'QUASI_PUBLIC_AND_PRIVATE_SECTOR',
            description: 'QUASI_PUBLIC_AND_PRIVATE_SECTOR_DESCRIPTION',
            text: 'QUASI_PUBLIC_AND_PRIVATE_SECTOR_TEXT'
        },
        {
            title: 'MEDIA_ANALYTICS_AND_PR',
            description: 'MEDIA_ANALYTICS_AND_PR_DESCRIPTION',
            text: 'MEDIA_ANALYTICS_AND_PR_TEXT'
        }
    ]
}

export default SituableBlocks;